import { useQuery, type QueryKey } from '@tanstack/react-query';
import service from '../service';
import type { SoulExample } from '@Types/soulExample';

export const soulExampleKeys = {
  forSoul: (soulId: string) => ['soul-examples', soulId] as const,
  detail: (id: string) => ['soul-example', id] as const,
};

export function useSoulExamples({
  soulId,
  enabled = true,
}: {
  soulId?: string;
  enabled?: boolean;
}) {
  return useQuery<SoulExample[]>({
    queryKey: soulExampleKeys.forSoul(soulId!) as unknown as QueryKey,
    queryFn: () => service.getSoulExamples(soulId!),
    enabled: enabled && !!soulId,
  });
}

export function useSoulExample({
  id,
  enabled = true,
}: {
  id?: string;
  enabled?: boolean;
}) {
  return useQuery<SoulExample>({
    queryKey: soulExampleKeys.detail(id!) as unknown as QueryKey,
    queryFn: () => service.getSoulExample(id!),
    enabled: enabled && !!id,
  });
}
